import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/ymparistooppi';
import { PRODUCT_IMAGE } from '../data/assets';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-seyes" data-id="element-148" data-mp="4mi2n8mfxkdf">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-149" data-mp="4jvyliyrdmzy" />

      <div className="relative mx-auto max-w-6xl px-8 pb-16 pt-4 sm:px-14 sm:pb-20 sm:pt-6 lg:pb-28" data-id="element-150" data-mp="x9umvc54pg3k">
        

        <div className="mt-4 flex flex-col sm:mt-12 lg:mt-16 lg:grid lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-12" data-id="element-151" data-mp="sa9rfbp63pvl">
          <div className="contents lg:block" data-id="element-152" data-mp="nbygsyr1tbcb">
            <motion.h1 initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE
          }} style={{
            hyphens: 'manual'
          }} className="order-1 text-center font-serif text-[1.85rem] leading-none sm:leading-[0.95] lg:text-left tracking-tight text-slate-900 sm:text-5xl lg:text-[3.35rem]" data-id="element-153" data-mp="3d1a4l90jrr80">
              <span className="relative inline-block whitespace-nowrap" data-id="element-154" data-mp="399bavmrkdbvg">
                <motion.span aria-hidden="true" initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 0.3,
                delay: 0.25,
                ease: EASE
              }} className="absolute inset-x-[-0.08em] bottom-[0.08em] top-[0.38em] -z-0 origin-left -rotate-1 rounded-[0.12em] bg-amber-300/80" data-id="element-155" data-mp="3e963pvuwgbj5" />
                <span className="relative" data-id="element-156" data-mp="2viewp0ydwx7x">Koko lukuvuoden</span>
              </span>{' '}
              ympäristöopin tunnit valmiiksi suunniteltuna. Luokkaan{' '}
              <span className="relative inline-block whitespace-nowrap italic text-red-700" data-id="element-157" data-mp="2hl9q8zurdwc5">
                5 minuutissa.
                <svg aria-hidden="true" viewBox="0 0 200 14" preserveAspectRatio="none" className="absolute -bottom-1.5 left-0 h-3 w-full sm:-bottom-2.5" data-id="element-158" data-mp="s1rrim0vq2t8">
                  <motion.path d="M3 9 C 45 3, 95 2, 135 6 S 185 11, 197 4" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" vectorEffect="non-scaling-stroke" initial={{
                  pathLength: 0
                }} animate={{
                  pathLength: 1
                }} transition={{
                  duration: 0.3,
                  delay: 0.35,
                  ease: EASE
                }} data-id="element-159" data-mp="na094yrvn3e6" />
                </svg>
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.08,
            ease: EASE
          }} className="order-3 mx-auto mt-4 max-w-xl text-center text-[15px] lg:mx-0 lg:text-left leading-snug text-slate-900/75 sm:mt-8 sm:text-xl sm:leading-relaxed" data-id="element-160" data-mp="110wo3msvrm2r">
              Ei enää suunnittelua tyhjästä. Vuosisuunnitelma, valmiit tunnit, 30 koetta, eriytetyt monisteet ja arviointi 1.–6. luokille – sekä viisi bonusta.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.16,
            ease: EASE
          }} className="order-4 mt-5 sm:mt-8 lg:mt-10" data-id="element-161" data-mp="268fybrpfs2hc">
              <div className="flex justify-center lg:justify-start" data-id="element-162" data-mp="2kx2f7xupp2ao">
                <CtaButton href="#offer-card" className="w-full sm:w-auto" data-id="element-163" data-mp="2p1jylvx5tdkx" />
              </div>
              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-xs text-slate-900/70 sm:mt-6 sm:gap-x-6 sm:text-sm lg:justify-start" data-id="element-164" data-mp="2tztr1yri202u">
                {heroGuarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-165" data-mp="zl10wf9dy1ia">
                    <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-166" data-mp="zndphb9nfa4b" />
                    {item}
                  </li>)}
              </ul>
            </motion.div>
          </div>

          <motion.figure initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.12,
          ease: EASE
        }} className="relative order-2 mx-auto mt-4 w-full max-w-md sm:mt-12 sm:pt-10 lg:mt-0" data-id="element-167" data-mp="3vk1k41bzy6yt">
            <div aria-hidden="true" className="absolute right-0 top-0 z-10 hidden -rotate-3 items-end gap-1 sm:flex" data-id="element-168" data-mp="3crpixhx2xbq9">
              <svg viewBox="0 0 60 50" className="h-10 w-12 text-red-700" fill="none" data-id="element-169" data-mp="3rh56kp1bd11q">
                <path d="M56 6 C 40 4, 18 12, 10 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-170" data-mp="3mp3migxwm615" />
                <path d="M4 32 L10 42 L18 34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-171" data-mp="2yyhs3sgtok9m" />
              </svg>
              <span className="font-serif text-xl italic leading-tight text-red-700" data-id="element-172" data-mp="19inkk74x1129">
                6 osaa
                <br data-id="element-173" data-mp="1e93xzr8qkmom" />+ 5 bonusta
              </span>
            </div>
            <img src={PRODUCT_IMAGE} alt="YMPÄRISTÖOPPI VALMIS -paketti: kuusi ympäristöopin osaa 1.–6. luokille – vuosisuunnitelma, valmiit tunnit, kokeet, monisteet ja arviointi" className="relative mx-auto h-60 w-auto drop-shadow-xl sm:h-auto sm:w-full" data-id="element-174" data-mp="1ebgnqqkqk1c8" />
          </motion.figure>
        </div>
      </div>
    </section>;
}